/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import BookingDetails from './BookingDetails/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaCardHeaderTitle from 'DesignSystem/TysiaCard/TysiaCardHeader/TysiaCardHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Content/Home/AppointmentBookings/Content"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let appointmentsValueData = fromData.useDataValue({ viewPath,
context: 'appointments',
})
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size={isMedia.mobile ? "small" : "large"}
 marginLeft="auto"
 marginRight="auto"
 flexGrow={0}
 marginTop={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
>
{childProps => (
<TysiaCardHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeaderTitle`}
 text="Appointment Bookings"
 level="h4"
/>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-2-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--fd-3-Z1Yf8zk': isMedia.mobile ? "column" : "row",'--ai-1-Z1Yf8zk': isMedia.mobile ? "flex-start" : "center"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mr-4-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="For Patients"
/>
<div
  data-testid="Content.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(appointmentsValueData) && appointmentsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="appointment"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/BookingDetails(${item?.id ?? item?._id ?? index})`}
      >
<BookingDetails
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/BookingDetails(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 alignSelf="flex-end"
 marginRight={dtSpaceS}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../Appointments/All/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../Appointments/All/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Details"
/>
)}
</TysiaButton>
</div>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }